import { useTranslation } from 'react-i18next';
import { KpiObjectType } from '@/api/entities/kpi';
import { useGetKpiModel } from '@/hooks/kpi.hooks';
import { useGetTab } from '@/hooks/tab.hooks';
import { KpiTab } from '@/type/ui/tab/kpiTab';
import { TabList } from '@/components/Tab/TabList';
import { TabItem } from '@/components/Tab/TabItem';
import Loader from '@/components/Loading/Loader';
import { KpiDashboardHeader } from '../components/KpiDashboardHeader';
import { KpiOverviewPanel } from '../components/KpiOverviewPanel';
import { PerClassIouPanel } from '../components/PerClassIouPanel';
import { PerClassAnnotationsPanel } from '../components/PerClassAnnotationsPanel';

export const KpiDamagesPage = () => {
  const { t } = useTranslation('kpi');

  const { currentTab, navigateToTab } = useGetTab({
    defaultTab: KpiTab.OVERVIEW,
  });

  const { model, summary, isLoading } = useGetKpiModel(KpiObjectType.DAMAGE);

  return (
    <>
      <KpiDashboardHeader
        t={t}
        title={
          <>
            <span>{t('common:kpi')}</span>
            &nbsp;&#8212;&nbsp;
            <span>{t('common:damages')}</span>
          </>
        }
        subtitle={`${t('iouBenchmark')} · ${t('damageModel')}`}
        updatedAt={model?.updatedAt}
      />
      <TabList className="mb-5">
        <TabItem
          text={t('overview')}
          leftIcon={<i className="ki-outline ki-bar-chart" />}
          active={currentTab === KpiTab.OVERVIEW}
          onChange={() => navigateToTab(KpiTab.OVERVIEW)}
        />
        <TabItem
          text={t('iou')}
          leftIcon={<i className="ki-outline ki-chart-line-up-2 !text-xl" />}
          active={currentTab === KpiTab.IOU}
          onChange={() => navigateToTab(KpiTab.IOU)}
        />
        <TabItem
          text={t('annotations')}
          leftIcon={<i className="ki-outline ki-graph" />}
          active={currentTab === KpiTab.ANNOTATIONS}
          onChange={() => navigateToTab(KpiTab.ANNOTATIONS)}
        />
      </TabList>
      {!isLoading && (
        <>
          {currentTab === KpiTab.OVERVIEW && (
            <KpiOverviewPanel
              t={t}
              type={KpiObjectType.DAMAGE}
              model={model}
              summary={summary}
            />
          )}
          {currentTab === KpiTab.IOU && (
            <PerClassIouPanel t={t} type={KpiObjectType.DAMAGE} model={model} />
          )}
          {currentTab === KpiTab.ANNOTATIONS && (
            <PerClassAnnotationsPanel
              t={t}
              type={KpiObjectType.DAMAGE}
              model={model}
            />
          )}
        </>
      )}
      {isLoading && <Loader />}
    </>
  );
};
